import React, { PropTypes } from 'react';
import { DragSource } from 'react-dnd';
import { MAPSERVER_URL, MAPSERVER_ROOT_DIR } from '../../constants/root';

class Legend extends React.Component {

	createImageArray(selectedLayers) {
		const base = `${MAPSERVER_URL}SERVICE=WMS&VERSION=1.1.1`;
		const tail = "REQUEST=getlegendgraphic&FORMAT=image/png";

		let images = {};

		selectedLayers.map(layer => {
			if (!images[layer.projeto]) {
				images[layer.projeto] = [];
			}
			
			images[layer.projeto]
				.push({
					name: layer.name, 
					url: `${base}&layer=${layer.layers}&map=${MAPSERVER_ROOT_DIR}${layer.path}${layer.mapfilename}&${tail}`
				});
		});

		return images;
	}

	renderImageList(images) {
		return images.map((image, i) => {
			return (
				<div className='legendaComTitulo' key={i}>
					<span>{image.name}</span>
					<img src={image.url} />
				</div>
			);
		});
	}

	renderBrumadinho(images) {
		if (images[2]) {
			return (
				<div>
					<h5>Brumadinho</h5>
					<div>{this.renderImageList(images[2])}</div>
				</div>
			);
		}
	}

	renderMariana(images) {
		if (images[1]) {
			return (
				<div>
					<h5>Mariana</h5>
					<div>{this.renderImageList(images[1])}</div>
				</div>
			);
		}
	}
	
	renderAssistenciaTecnica(images) {
		if (images[3]) {
			return (
				<div>
					<h5>Assistência Técnica</h5>
					<div>{this.renderImageList(images[3])}</div>
				</div>
			);
		}
	}

	renderImages() {
		const images = this.createImageArray(this.props.layers);
		if (images[1] || images[2] || images[3]) {
			return (
				<div>
					{this.renderBrumadinho(images)}
					{this.renderMariana(images)}
					{this.renderAssistenciaTecnica(images)}
				</div>
			);
		}
	}

	render () {
		const { left, top, isDragging, connectDragSource, layers } = this.props;

		if ( isDragging ) return null; // Do not show while dragging
		if ( layers.length === 0 ) return null; // Do not show if there is no layers selected
		return connectDragSource(
			<div className="legend-box" style={{top: `${top}px`, left: `${left}px`}}>
				{this.renderImages()}
			</div>
		);
	}
}

const boxSource = {
	beginDrag(props) {
		const { left, top } = props;
		return { left, top };
	}
};

export default DragSource("LEGEND", boxSource, (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	isDragging: monitor.isDragging()
}))(Legend);

Legend.propTypes = {
	left: PropTypes.number.isRequired,
	top: PropTypes.number.isRequired,
	isDragging: PropTypes.bool.isRequired,
	connectDragSource: PropTypes.func.isRequired,
	layers: PropTypes.array.isRequired
};


// WEBPACK FOOTER //
// ./src/components/Explorer/Legend.js